module.exports = __webpack_public_path__ + "img/678w.d29fc9f.jpg";